<template>
  <div>
      <EditCompanyEmisorasForm></EditCompanyEmisorasForm>
  </div>
</template>

<script>
import EditCompanyEmisorasForm from '@/components/Dashboard/CompaniesEmisoras/EditCompanyEmisorasForm'
export default {
  components: { EditCompanyEmisorasForm },

}
</script>